
import Vue from "vue";
import store from "@/store";

export default Vue.extend({
  computed: {
    uiFeature: {
      get(): Record<string, any> {
        return store.getters.uiFeatureModule.uiFeature;
      },
    },
    largeText: function () {
      return (first: string) => {
        let temp: string;
        if (first) {
          temp = this.uiFeature[first].largeText;
          return temp ? temp : "";
        } else {
          return "";
        }
      };
    },
    displayName: function () {
      return (first: string) => {
        let temp: string;
        if (first) {
          temp = this.uiFeature[first].displayName;
          return temp ? temp : "";
        } else {
          return "";
        }
      };
    },
    gpcChildren: function () {
      return (propName: string) => {
        let temp: [];
        if (propName) {
          temp = this.uiFeature[propName].children;
          return temp ? temp : [];
        } else {
          return [];
        }
      };
    },
  },
});
